import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Icon from "./icon/Icon";

const PreviewImg = ({
	file,
	icon,
	SUPPORTED_FORMATS = [
		"image/jpg",
		"image/jpeg",
		"image/png",
		"application/pdf",
	],
}) => {
	const [preview, setPreview] = useState(null);
	const [isImageError, setIsImageError] = useState(false);

	useEffect(() => {
		if (
			typeof file === "string" ||
			(file && SUPPORTED_FORMATS.includes(file.type))
		) {
			if (typeof file === "string") {
				setPreview(file);
				setIsImageError(false);
			} else {
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => {
					setPreview(reader.result);
				};
			}
		}
	}, [file]);

	const handleImageError = () => {
		setIsImageError(true);
	};

	return (
		<div className="d-flex justify-content-center">
			{typeof file === "string" && !isImageError ? (
				<img
					src={preview}
					alt="preview"
					onError={handleImageError}
					style={{ objectFit: "scale-down" }}
					width="150px"
					height="150px"
				/>
			) : typeof file === "string" && isImageError ? (
				<iframe
					src={preview}
					width="150px"
					height="150px"
					title="PDF preview"
				></iframe>
			) : file && file.type === "application/pdf" ? (
				<iframe
					src={preview}
					width="150px"
					height="150px"
					title="PDF preview"
				></iframe>
			) : file && file.type !== "application/pdf" ? (
				<img
					src={preview}
					alt="preview"
					onError={handleImageError}
					style={{ objectFit: "scale-down" }}
					width="150px"
					height="150px"
				/>
			) : (
				<Icon icon={icon} width="50px" height="50px" />
			)}
		</div>
	);
};

PreviewImg.propTypes = {
	file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	icon: PropTypes.string.isRequired,
};

PreviewImg.defaultProps = {};

export default PreviewImg;
